export default "__VITE_ASSET__BOOD8at3__"